export const ArrowRightSvg = (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
        <defs>
            <rect id="path-1" x="0" y="0" width="18" height="18"></rect>
        </defs>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-362, -215)">
                <g id="大模型tag" transform="translate(82, 209)">
                    <g id="icon_leftarrow_18" transform="translate(280, 6)">
                        <mask id="mask-2" fill="white">
                            <use href="#path-1"></use>
                        </mask>
                        <g id="path-1"></g>
                        <g id="编组" mask="url(#mask-2)" stroke-linejoin="round">
                            <g transform="translate(3.3824, 4.75)">
                                <g transform="translate(4.2426, 4.2426) rotate(-45) translate(-4.2426, -4.2426)translate(1.2426, 1.2426)">
                                    <polyline
                                        id="路径"
                                        stroke="currentColor"
                                        stroke-width="1.2"
                                        transform="translate(3, 3) rotate(90) translate(-3, -3)"
                                        points="-2.84217094e-14 0 6 0 6 6"
                                    ></polyline>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const CheckSvg = (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
        <defs>
            <path d="M0,0 L18,0 L18,18 L0,18 L0,0 Z" id="path-1"></path>
            <linearGradient x1="100%" y1="21.875%" x2="50%" y2="78.125%" id="linearGradient-2">
                <stop stop-color="#A871E3" offset="0%"></stop>
                <stop stop-color="#165DFF" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="切图" transform="translate(-142, -1044)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组-22" transform="translate(82, 264)">
                        <g id="编组" transform="translate(60, 60.0003)">
                            <g id="编组-7备份-2" transform="translate(0, 66)">
                                <g id="对号icon" transform="translate(0, 6)" href="#path-1">
                                    <rect id="矩形-3" x="0" y="0" width="18" height="18"></rect>
                                    <g
                                        id="Chronify-✧-SaaS-和-Startup-Framer-模板"
                                        stroke-width="1"
                                        fill-rule="evenodd"
                                        transform="translate(3, 4.4997)"
                                        fill="url(#linearGradient-2)"
                                    >
                                        <path
                                            d="M11.7488159,0.263519063 C12.083728,0.61498394 12.083728,1.18470854 11.7488159,1.53617342 L4.88554436,8.73648094 C4.55053104,9.08783969 4.00747443,9.08783969 3.67246112,8.73648094 L0.240825352,5.13632718 C-0.0842982945,4.7831711 -0.079648569,4.22181182 0.251275905,3.87463657 C0.58220038,3.52746133 1.11728324,3.52258327 1.45390859,3.86367282 L4.27900274,6.82749941 L10.5357326,0.263519063 C10.870746,-0.0878396877 11.4138026,-0.0878396877 11.7488159,0.263519063 Z"
                                            id="路径"
                                            fill-rule="nonzero"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

// agrnt tabs icons
export const IntelligentProSvg = (
    <svg viewBox="0 0 24 24" version="1.1">
        <title>tab1_icon_zhinengtipro01</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800" transform="translate(-452, -843)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组-26" transform="translate(428, 180)">
                        <g id="tab1_icon_zhinengtipro01" transform="translate(24, 15)">
                            <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                            <g id="icon_zhinengtipro">
                                <path
                                    d="M19.4668457,8.68954967 L19.7134248,8.12413911 C20.1528939,7.11608423 20.9445427,6.31346599 21.9322814,5.87438435 L22.69193,5.53671058 C23.1026879,5.3541249 23.1026879,4.75673009 22.69193,4.57414441 L21.9748594,4.25534134 C20.9616094,3.8049586 20.1557384,2.97263943 19.7238249,1.93031697 L19.4706679,1.3193555 C19.2941336,0.893547328 18.7057749,0.893547328 18.5293294,1.3193555 L18.2760836,1.93031697 C17.8441701,2.97263943 17.0383879,3.8049586 16.0252268,4.25534134 L15.3080673,4.57414441 C14.8973095,4.75673009 14.8973095,5.3541249 15.3080673,5.53671058 L16.0676271,5.87438435 C17.0554547,6.31346599 17.8470146,7.11608423 18.2865726,8.12413911 L18.5331517,8.68954967 C18.7135971,9.10347925 19.2864003,9.10347925 19.4668457,8.68954967 Z"
                                    id="路径"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                ></path>
                                <path
                                    d="M14,5 C14,7.76142375 16.2385763,10 19,10 C20.1261445,10 21.1653335,9.62769913 22.0011995,8.99946494 L22,19 C22,19.5522847 21.5522847,20 21,20 L3,20 C2.44771525,20 2,19.5522847 2,19 L2,5 C2,4.44771525 2.44771525,4 3,4 L14.1002591,3.9988136 C14.0345146,4.32229129 14,4.65711499 14,5 Z"
                                    id="形状结合"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                ></path>
                                <g
                                    id="PRO"
                                    stroke-width="1"
                                    fill-rule="evenodd"
                                    transform="translate(5, 11)"
                                    fill="#FFFFFF"
                                >
                                    <path
                                        d="M0.25,5.84 L0.886,5.84 C1.02407119,5.84 1.136,5.72807119 1.136,5.59 L1.136,3.912 L1.136,3.912 L2.112,3.912 C3.48,3.912 4.112,3.096 4.112,2.016 C4.112,0.912 3.496,0.128 2.112,0.128 L0.25,0.128 C0.111928813,0.128 -2.53632657e-17,0.239928813 0,0.378 L0,5.59 C1.69088438e-17,5.72807119 0.111928813,5.84 0.25,5.84 Z M1.136,1.104 L2.048,1.104 C2.648,1.104 2.936,1.44 2.936,2.016 C2.936,2.576 2.648,2.936 2.048,2.936 L1.136,2.936 L1.136,1.104 Z"
                                        id="形状"
                                        fill-rule="nonzero"
                                    ></path>
                                    <path
                                        d="M7.87938908,5.84 L8.58161138,5.84 C8.71968256,5.84 8.83161138,5.72807119 8.83161138,5.59 C8.83161138,5.55311222 8.82344832,5.51668152 8.80770768,5.48332076 L7.904,3.568 L7.904,3.568 C8.52,3.328 8.864,2.768 8.864,1.904 C8.864,0.728 8.184,0.128 6.904,0.128 L5.026,0.128 C4.88792881,0.128 4.776,0.239928813 4.776,0.378 L4.776,5.59 C4.776,5.72807119 4.88792881,5.84 5.026,5.84 L5.662,5.84 C5.80007119,5.84 5.912,5.72807119 5.912,5.59 L5.912,3.704 L5.912,3.704 L6.832,3.704 L7.64823749,5.68523099 C7.68682083,5.77888328 7.77810025,5.84 7.87938908,5.84 Z M6.808,2.744 L5.912,2.744 L5.912,1.104 L6.808,1.104 C7.392,1.104 7.688,1.384 7.688,1.904 C7.688,2.448 7.392,2.744 6.808,2.744 Z"
                                        id="形状"
                                        fill-rule="nonzero"
                                    ></path>
                                    <path
                                        d="M11.856,5.96 C13.432,5.96 14.12,4.872 14.12,2.976 C14.12,1.064 13.44,0 11.856,0 C10.328,0 9.6,1.072 9.6,2.976 C9.6,4.872 10.296,5.96 11.856,5.96 Z M11.856,4.92 C11.088,4.92 10.784,4.288 10.784,2.96 C10.784,1.672 11.088,1.048 11.856,1.048 C12.64,1.048 12.936,1.672 12.936,2.944 C12.936,4.296 12.64,4.92 11.856,4.92 Z"
                                        id="形状"
                                        fill-rule="nonzero"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const SelfPlanSvg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800" transform="translate(-632, -843)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组-26" transform="translate(428, 180)">
                        <g id="编组-25备份" transform="translate(180, 0)">
                            <g id="tab1_icon_zizhuguihua-agent02" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                <path
                                    d="M12.5070201,2.29824713 L15.1341778,3.8445291 C15.0464345,4.21542358 15,4.60228911 15,5 C15,7.76142375 17.2385763,10 20,10 C20.1689898,10 20.3360215,9.99161647 20.500702,9.97524263 L20.5,16.4280539 C20.5,16.7824182 20.3124588,17.1103183 20.0070201,17.2899882 L12.5070201,21.7017529 C12.194071,21.8858406 11.805929,21.8858406 11.4929799,21.7017529 L3.99297987,17.2899882 C3.68754118,17.1103183 3.5,16.7824182 3.5,16.4280539 L3.5,7.57194605 C3.5,7.21758178 3.68754118,6.88968166 3.99297987,6.71001184 L11.4929799,2.29824713 C11.805929,2.11415942 12.194071,2.11415942 12.5070201,2.29824713 Z"
                                    id="形状结合"
                                    fill="currentColor"
                                ></path>
                                <g id="编组" transform="translate(16, 1)" fill="currentColor" fill-rule="nonzero">
                                    <path
                                        d="M4.46684671,7.6895503 L4.71342584,7.12413974 C5.15289492,6.11608486 5.9445437,5.31346662 6.93228245,4.87438498 L7.69193106,4.53671121 C8.10268887,4.35412553 8.10268887,3.75673071 7.69193106,3.57414504 L6.97486047,3.25534197 C5.96161047,2.80495923 5.15573938,1.97264006 4.7238259,0.930317598 L4.47066896,0.319356127 C4.29413466,-0.106452042 3.70577587,-0.106452042 3.52933046,0.319356127 L3.27608463,0.930317598 C2.84417115,1.97264006 2.03838895,2.80495923 1.02522784,3.25534197 L0.308068356,3.57414504 C-0.102689452,3.75673071 -0.102689452,4.35412553 0.308068356,4.53671121 L1.06762808,4.87438498 C2.05545571,5.31346662 2.84701561,6.11608486 3.28657358,7.12413974 L3.53315271,7.6895503 C3.71359814,8.10347988 4.28640128,8.10347988 4.46684671,7.6895503 Z"
                                        id="路径"
                                    ></path>
                                </g>
                                <path
                                    d="M8.27380878,8.9312579 L11.9929376,11.2634852 L11.9929376,11.2634852 L15.5931591,8.94165163 C15.8252267,8.79198794 16.1346811,8.85878954 16.2843448,9.09085718 C16.2865625,9.09429599 16.288738,9.0977619 16.2908706,9.10125412 L16.5503742,9.5261913 C16.6921743,9.75838909 16.6222881,10.0613493 16.3931032,10.207969 L12.2711818,12.8449451 C12.1088814,12.9487759 11.901362,12.9501142 11.7377358,12.8483855 L7.49012829,10.2075865 C7.25903276,10.063911 7.18526503,9.7618077 7.32413615,9.52779363 L7.57818543,9.09969089 C7.71911074,8.86221527 8.0258653,8.78394578 8.26334091,8.92487109 C8.26685618,8.92695716 8.27034573,8.92908625 8.27380878,8.9312579 Z"
                                    id="路径-5"
                                    fill="#FFFFFF"
                                    fill-rule="nonzero"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const WorkflowSvg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800" transform="translate(-842, -843)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组-26" transform="translate(428, 180)">
                        <g id="编组-25备份-2" transform="translate(390, 0)">
                            <g id="tab1_icon_gongzuoliu-agent03" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                <g
                                    id="图形"
                                    transform="translate(12, 12) scale(1, -1) translate(-12, -12)"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                >
                                    <path
                                        d="M9,6 C9,7.30622 8.16519,8.41746 7,8.82929 L7,9 C7,10.1046 7.89543,11 9,11 L15,11 C16.1046,11 17,10.1046 17,9 L17,8.82929 C15.8348,8.41746 15,7.30622 15,6 C15,4.34315 16.3431,3 18,3 C19.6569,3 21,4.34315 21,6 C21,7.30622 20.1652,8.41746 19,8.82929 L19,9 C19,11.2091 17.2091,13 15,13 L13,13 L13,15.1707 C14.1652,15.5825 15,16.6938 15,18 C15,19.6569 13.6569,21 12,21 C10.3431,21 9,19.6569 9,18 C9,16.6938 9.83481,15.5825 11,15.1707 L11,13 L9,13 C6.79086,13 5,11.2091 5,9 L5,8.82929 C3.83481,8.41746 3,7.30622 3,6 C3,4.34315 4.34315,3 6,3 C7.65685,3 9,4.34315 9,6 Z"
                                        id="路径"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const KnowledgeBaseSvg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800" transform="translate(-1034, -843)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组-26" transform="translate(428, 180)">
                        <g id="编组-25备份-3" transform="translate(582, 0)">
                            <g id="tab1_icon_zhishikurag_04" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                <path
                                    d="M20,9.3 L20,20 C20,20.5522847 19.5522847,21 19,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 L13.7777778,3 L13.7777778,3 L13.7777778,8.4 C13.7777778,8.897052 14.1757333,9.3 14.6666667,9.3 L20,9.3 Z M20,7.5 L15.5555556,7.5 L15.5555556,3.002862 L20,7.5 Z"
                                    id="形状"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                ></path>
                                <path
                                    d="M8.5,12 L11.5,12 C11.7761424,12 12,12.2238576 12,12.5 L12,13 C12,13.2761424 11.7761424,13.5 11.5,13.5 L8.5,13.5 C8.22385763,13.5 8,13.2761424 8,13 L8,12.5 C8,12.2238576 8.22385763,12 8.5,12 Z M8.5,15 L15.5,15 C15.7761424,15 16,15.2238576 16,15.5 L16,16 C16,16.2761424 15.7761424,16.5 15.5,16.5 L8.5,16.5 C8.22385763,16.5 8,16.2761424 8,16 L8,15.5 C8,15.2238576 8.22385763,15 8.5,15 Z"
                                    id="形状结合"
                                    fill="#FFFFFF"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const FullChainSvg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800" transform="translate(-1214, -843)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组-26" transform="translate(428, 180)">
                        <g id="编组-25备份-4" transform="translate(762, 0)">
                            <g id="tab1_icon_quanlianlukeguance05" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="23.9999983" height="23.9999924"></rect>
                                <g id="图形">
                                    <path
                                        d="M19.4668457,8.68954967 L19.7134248,8.12413911 C20.1528939,7.11608423 20.9445427,6.31346599 21.9322814,5.87438435 L22.69193,5.53671058 C23.1026879,5.3541249 23.1026879,4.75673009 22.69193,4.57414441 L21.9748594,4.25534134 C20.9616094,3.8049586 20.1557384,2.97263943 19.7238249,1.93031697 L19.4706679,1.3193555 C19.2941336,0.893547328 18.7057749,0.893547328 18.5293294,1.3193555 L18.2760836,1.93031697 C17.8441701,2.97263943 17.0383879,3.8049586 16.0252268,4.25534134 L15.3080673,4.57414441 C14.8973095,4.75673009 14.8973095,5.3541249 15.3080673,5.53671058 L16.0676271,5.87438435 C17.0554547,6.31346599 17.8470146,7.11608423 18.2865726,8.12413911 L18.5331517,8.68954967 C18.7135971,9.10347925 19.2864003,9.10347925 19.4668457,8.68954967 Z"
                                        id="路径"
                                        fill="currentColor"
                                        fill-rule="nonzero"
                                    ></path>
                                    <path
                                        d="M14,5 C14,7.76142375 16.2385763,10 19,10 C20.1261445,10 21.1653335,9.62769913 22.0011995,8.99946494 L22,19 C22,19.5522847 21.5522847,20 21,20 L3,20 C2.44771525,20 2,19.5522847 2,19 L2,5 C2,4.44771525 2.44771525,4 3,4 L14.1002591,3.9988136 C14.0345146,4.32229129 14,4.65711499 14,5 Z"
                                        id="形状结合"
                                        fill="currentColor"
                                        fill-rule="nonzero"
                                    ></path>
                                    <path
                                        d="M13.1308716,16.7531593 L10.3636364,9.92752961 L10.3636364,9.92752961 L9.22499812,12.7360781 C9.14154725,12.9419168 8.94161804,13.0765968 8.71950632,13.0765968 L6.27272727,13.0765968 C6.12210416,13.0765968 6,12.9544926 6,12.8038695 L6,12.1961132 C6,12.0454901 6.12210416,11.9233859 6.27272727,11.9233859 L8.3676,11.9233859 L8.3676,11.9233859 L9.85814434,8.24683716 C9.97132745,7.96766181 10.2893968,7.83309852 10.5685722,7.94628163 C10.7052768,8.00170434 10.8137052,8.11013277 10.8691278,8.2468374 L13.6363636,15.0724589 L13.6363636,15.0724589 L14.775002,12.2639049 C14.8584528,12.0580661 15.0583821,11.9233859 15.2804939,11.9233859 L17.7272727,11.9233859 C17.8778958,11.9233859 18,12.0454901 18,12.1961132 L18,12.8038695 C18,12.9544926 17.8778958,13.0765968 17.7272727,13.0765968 L15.6324,13.0765968 L15.6324,13.0765968 L14.1418554,16.7531591 C14.0286726,17.0323346 13.7106034,17.1668983 13.4314279,17.0537155 C13.2947229,16.9982929 13.1862943,16.8898642 13.1308716,16.7531593 Z"
                                        id="路径"
                                        stroke="#FFFFFF"
                                        stroke-width="0.25"
                                        fill="#FFFFFF"
                                        fill-rule="evenodd"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

// model tabs icons
export const ErnieIconSvg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab2_icon_ERNIE01</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-637, -2398)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组备份-65" transform="translate(0, 1320)">
                        <g id="编组-26备份" transform="translate(82.5, 415)">
                            <g transform="translate(530.5, 0)">
                                <g id="tab2_icon_ERNIE01" transform="translate(24, 15)">
                                    <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                    <path
                                        d="M20.5,7.57194605 L20.5,16.4280539 C20.5,16.7824182 20.3124588,17.1103183 20.0070201,17.2899882 L12.5070201,21.7017529 C12.3505456,21.7937967 12.1752728,21.8398187 12,21.8398187 L12,12.249 L20.4909729,7.43775776 C20.4969427,7.4818868 20.5,7.52670071 20.5,7.57194605 Z M12.5070201,2.29824713 L18.884,6.04818135 L10.5069874,10.7966445 L10,11.0839374 L9.999,20.8231813 L3.99297987,17.2899882 C3.68754118,17.1103183 3.5,16.7824182 3.5,16.4280539 L3.5,7.57194605 C3.5,7.21758178 3.68754118,6.88968166 3.99297987,6.71001184 L11.4929799,2.29824713 C11.805929,2.11415942 12.194071,2.11415942 12.5070201,2.29824713 Z"
                                        id="形状结合"
                                        fill="currentColor"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const VerticalModelSvg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab2_icon_chuileichangjing02</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-850, -2398)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组备份-65" transform="translate(0, 1320)">
                        <g id="编组-26备份" transform="translate(82.5, 415)">
                            <g transform="translate(530.5, 0)">
                                <g id="编组-25备份" transform="translate(213, 0)">
                                    <g id="tab2_icon_chuileichangjing02" transform="translate(24, 15)">
                                        <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                        <path
                                            d="M7.02631579,3 C9.24998842,3 11.0526316,4.80264316 11.0526316,7.02631579 L11.0526316,11.0526316 L7.02631579,11.0526316 C4.80264316,11.0526316 3,9.24998842 3,7.02631579 C3,4.80264316 4.80264316,3 7.02631579,3 Z M7.02631579,12.9473684 L11.0526316,12.9473684 L11.0526316,16.9736842 C11.0526316,19.1973474 9.24998842,21 7.02631579,21 C4.80264316,21 3,19.1973474 3,16.9736842 C3,14.7500211 4.80264316,12.9473684 7.02631579,12.9473684 Z M16.9736842,3 C19.1973474,3 21,4.80264316 21,7.02631579 C21,9.24998842 19.1973474,11.0526316 16.9736842,11.0526316 L12.9473684,11.0526316 L12.9473684,7.02631579 C12.9473684,4.80264316 14.7500211,3 16.9736842,3 Z M12.9473684,12.9473684 L16.9736842,12.9473684 C19.1973474,12.9473684 21,14.7500211 21,16.9736842 C21,19.1973474 19.1973474,21 16.9736842,21 C14.7500211,21 12.9473684,19.1973474 12.9473684,16.9736842 L12.9473684,12.9473684 Z"
                                            id="形状"
                                            fill="currentColor"
                                            fill-rule="nonzero"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const OthersModelAvg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab2_icon_disanfang03</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-1045, -2398)">
                <g id="编组" transform="translate(0, 648)">
                    <g id="编组备份-65" transform="translate(0, 1320)">
                        <g id="编组-26备份" transform="translate(82.5, 415)">
                            <g transform="translate(530.5, 0)">
                                <g id="编组-25备份-2" transform="translate(408, 0)">
                                    <g id="tab2_icon_disanfang03" transform="translate(24, 15)">
                                        <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                        <path
                                            d="M20.3164093,5.21460796 C22.0446602,7.45979962 21.8802876,10.6929633 19.8230316,12.7501232 C19.1842473,13.3889911 18.1484745,13.3889911 17.5096903,12.7501232 L11.2498469,6.4903433 C10.610976,5.85151001 10.610976,4.81575934 11.2498469,4.17692605 C13.3070163,2.11972627 16.5402555,1.9553059 18.7854401,3.68367185 L19.2317566,3.23734943 C19.4270167,3.04208594 19.7435986,3.04208288 19.9388625,3.23734261 L20.7627189,4.06117796 C20.9579831,4.256438 20.9579865,4.57302048 20.7627265,4.76828474 C20.7627262,4.768285 20.762726,4.76828527 20.7627257,4.76828554 L20.3164093,5.21460796 L20.3164093,5.21460796 Z M9.60508131,12.1940474 L11.8059252,14.3948812 C11.8534703,14.309924 11.913313,14.2301629 11.9854534,14.1579363 L13.16287,12.9805284 C13.3581319,12.7852673 13.6747132,12.7852673 13.8699751,12.9805284 L14.6938391,13.8043821 C14.8891017,13.9996438 14.8891024,14.3162263 14.6938407,14.5114889 C14.6938402,14.5114894 14.6938396,14.5114899 14.6938391,14.5114905 L13.5164225,15.6888984 L13.5164225,15.6888984 C13.4442822,15.7610384 13.3644341,15.8208808 13.2795631,15.8684257 L13.7673982,16.3563452 C14.4438549,17.0327121 14.4438549,18.1294483 13.7673982,18.8058152 L12.848886,19.7244098 C10.7426993,21.8305869 7.47232473,22.0630284 5.10919532,20.4217345 L4.62945611,20.9014743 C4.43419352,21.096736 4.11761103,21.0967352 3.92234933,20.9014726 C3.92234888,20.9014722 3.92234842,20.9014717 3.92234796,20.9014713 L3.09850996,20.0776176 C2.90324955,19.8823548 2.9032509,19.5657734 3.09851296,19.3705122 L3.57825216,18.8907725 L3.57825216,18.8907725 C1.93697582,16.5276453 2.1694176,13.2573551 4.27558011,11.151178 L5.19414427,10.2326008 C5.87055758,9.55619057 6.96723828,9.55619057 7.64365159,10.2326008 L8.13146939,10.7204163 C8.17900581,10.6355457 8.23886586,10.555698 8.31104086,10.483558 L9.48842544,9.30613545 C9.68368583,9.11087155 10.0002683,9.1108687 10.1955322,9.30612908 C10.195535,9.30613187 10.1955378,9.30613466 10.1955406,9.30613745 L11.0193623,10.1299988 C11.2146216,10.3252638 11.2146169,10.6418463 11.0193519,10.8371056 C11.0193517,10.8371058 11.0193515,10.837106 11.0193513,10.8371062 L9.84198402,12.0144335 L9.84198402,12.0144335 C9.76980035,12.0866601 9.68996098,12.1465026 9.60508131,12.1940474 Z"
                                            id="形状"
                                            fill="currentColor"
                                            fill-rule="nonzero"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

// DateBuilder

export const DateBuilder1Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab3_icon_gaoxiaoshuju01</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-513, -4609)">
                <g id="编组" transform="translate(0, 4414)">
                    <g id="编组-26备份-2" transform="translate(489, 180)">
                        <g id="tab3_icon_gaoxiaoshuju01" transform="translate(24, 15)">
                            <rect id="矩形" x="0" y="0" width="23.9999983" height="23.9999924"></rect>
                            <path
                                d="M4,13 L6,13 C6.55228475,13 7,13.4477153 7,14 L7,20 C7,20.5522847 6.55228475,21 6,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,14 C3,13.4477153 3.44771525,13 4,13 Z M18,9 L20,9 C20.5522847,9 21,9.44771525 21,10 L21,20 C21,20.5522847 20.5522847,21 20,21 L18,21 C17.4477153,21 17,20.5522847 17,20 L17,10 C17,9.44771525 17.4477153,9 18,9 Z M11,3 L13,3 C13.5522847,3 14,3.44771525 14,4 L14,20 C14,20.5522847 13.5522847,21 13,21 L11,21 C10.4477153,21 10,20.5522847 10,20 L10,4 C10,3.44771525 10.4477153,3 11,3 Z"
                                id="形状"
                                fill="currentColor"
                                fill-rule="nonzero"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const DateBuilder2Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab3_icon_duomotai02</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-708, -4609)">
                <g id="编组" transform="translate(0, 4414)">
                    <g id="编组-26备份-2" transform="translate(489, 180)">
                        <g id="编组-25备份" transform="translate(195, 0)">
                            <g id="tab3_icon_duomotai02" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                <path
                                    d="M12.39349,5.38888889 L20.55,5.38888889 C21.074685,5.38888889 21.5,5.81173556 21.5,6.33333333 L21.5,19.5555556 C21.5,20.0771722 21.074685,20.5 20.55,20.5 L3.45,20.5 C2.925334,20.5 2.5,20.0771722 2.5,19.5555556 L2.5,4.44444444 C2.5,3.92284667 2.925334,3.5 3.45,3.5 L10.49349,3.5 L12.39349,5.38888889 Z M11.05,9.16666667 L11.05,16.7222222 L12.95,16.7222222 L12.95,9.16666667 L11.05,9.16666667 Z M14.85,12 L14.85,16.7222222 L16.75,16.7222222 L16.75,12 L14.85,12 Z M7.25,13.8888889 L7.25,16.7222222 L9.15,16.7222222 L9.15,13.8888889 L7.25,13.8888889 Z"
                                    id="形状"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const DateBuilder3Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab3_icon_yizhanshigaoxingneng03</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-921, -4609)">
                <g id="编组" transform="translate(0, 4414)">
                    <g id="编组-26备份-2" transform="translate(489, 180)">
                        <g id="编组-25备份-2" transform="translate(408, 0)">
                            <g id="tab3_icon_yizhanshigaoxingneng03" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                <path
                                    d="M12,2.5 C17.24666,2.5 21.5,6.7532925 21.5,12 C21.5,17.24666 17.24666,21.5 12,21.5 C6.7532925,21.5 2.5,17.24666 2.5,12 C2.5,6.7532925 6.7532925,2.5 12,2.5 Z M16.36639,7.6336195 C16.17202,7.439297 15.866215,7.412716 15.641255,7.570606 C12.89661,9.4972155 11.34697,10.637795 10.992335,10.992335 C10.43592,11.548845 10.43592,12.451155 10.992335,13.007665 C11.548845,13.56408 12.451155,13.56408 13.007665,13.007665 C13.21562,12.799615 14.35505,11.249025 16.425765,8.355971 C16.585365,8.1330725 16.56019,7.827448 16.36639,7.6336195 Z M17.225,11.05 C16.700315,11.05 16.275,11.475315 16.275,12 C16.275,12.524685 16.700315,12.95 17.225,12.95 C17.749685,12.95 18.175,12.524685 18.175,12 C18.175,11.475315 17.749685,11.05 17.225,11.05 Z M6.775,11.05 C6.250334,11.05 5.825,11.475315 5.825,12 C5.825,12.524685 6.250334,12.95 6.775,12.95 C7.299666,12.95 7.725,12.524685 7.725,12 C7.725,11.475315 7.299666,11.05 6.775,11.05 Z M8.977119,7.6336195 C8.606125,7.262616 8.0046135,7.262616 7.6336195,7.6336195 C7.262616,8.0046135 7.262616,8.606125 7.6336195,8.977119 C8.0046135,9.348113 8.606125,9.348113 8.977119,8.977119 C9.348113,8.606125 9.348113,8.0046135 8.977119,7.6336195 Z M12,5.825 C11.475315,5.825 11.05,6.250334 11.05,6.775 C11.05,7.299666 11.475315,7.725 12,7.725 C12.524685,7.725 12.95,7.299666 12.95,6.775 C12.95,6.250334 12.524685,5.825 12,5.825 Z"
                                    id="形状"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const DateBuilder4Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab3_icon_zhinengshujufenxi04</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="千帆大模型平台-1800备份-3" transform="translate(-1152, -4609)">
                <g id="编组" transform="translate(0, 4414)">
                    <g id="编组-26备份-2" transform="translate(489, 180)">
                        <g id="编组-25备份-5" transform="translate(639, 0)">
                            <g id="tab3_icon_zhinengshujufenxi04" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="23.9999983" height="23.9999924"></rect>
                                <g id="图形" fill="currentColor" fill-rule="nonzero">
                                    <path
                                        d="M19.4668457,8.68954967 L19.7134248,8.12413911 C20.1528939,7.11608423 20.9445427,6.31346599 21.9322814,5.87438435 L22.69193,5.53671058 C23.1026879,5.3541249 23.1026879,4.75673009 22.69193,4.57414441 L21.9748594,4.25534134 C20.9616094,3.8049586 20.1557384,2.97263943 19.7238249,1.93031697 L19.4706679,1.3193555 C19.2941336,0.893547328 18.7057749,0.893547328 18.5293294,1.3193555 L18.2760836,1.93031697 C17.8441701,2.97263943 17.0383879,3.8049586 16.0252268,4.25534134 L15.3080673,4.57414441 C14.8973095,4.75673009 14.8973095,5.3541249 15.3080673,5.53671058 L16.0676271,5.87438435 C17.0554547,6.31346599 17.8470146,7.11608423 18.2865726,8.12413911 L18.5331517,8.68954967 C18.7135971,9.10347925 19.2864003,9.10347925 19.4668457,8.68954967 Z"
                                        id="路径"
                                    ></path>
                                    <path
                                        d="M14,5 C14,7.76142375 16.2385763,10 19,10 C20.1261445,10 21.1653335,9.62769913 22.0011995,8.99946494 L22,19 C22,19.5522847 21.5522847,20 21,20 L3,20 C2.44771525,20 2,19.5522847 2,19 L2,5 C2,4.44771525 2.44771525,4 3,4 L14.1002591,3.9988136 C14.0345146,4.32229129 14,4.65711499 14,5 Z M8.5,12.9090909 L7.5,12.9090909 C7.22385763,12.9090909 7,13.1329485 7,13.4090909 L7,16.5 C7,16.7761424 7.22385763,17 7.5,17 L8.5,17 C8.77614237,17 9,16.7761424 9,16.5 L9,13.4090909 C9,13.1329485 8.77614237,12.9090909 8.5,12.9090909 Z M12.5,8 L11.5,8 C11.2238576,8 11,8.22385763 11,8.5 L11,16.5 C11,16.7761424 11.2238576,17 11.5,17 L12.5,17 C12.7761424,17 13,16.7761424 13,16.5 L13,8.5 C13,8.22385763 12.7761424,8 12.5,8 Z M16.5,10.4545455 L15.5,10.4545455 C15.2238576,10.4545455 15,10.6784031 15,10.9545455 L15,16.5 C15,16.7761424 15.2238576,17 15.5,17 L16.5,17 C16.7761424,17 17,16.7761424 17,16.5 L17,10.9545455 C17,10.6784031 16.7761424,10.4545455 16.5,10.4545455 Z"
                                        id="形状结合"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const successCases1Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab4_icon_zhengwu01</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="切图" transform="translate(-525, -6136)">
                <g id="编组" transform="translate(0, 6049)">
                    <g transform="translate(83, -30)" id="编组-26">
                        <g transform="translate(418, 102)">
                            <g id="tab4_icon_zhengwu01" transform="translate(24, 15)">
                                <rect id="矩形" x="0" y="0" width="24" height="23.9999924"></rect>
                                <path
                                    d="M3.36440066,18.3267974 L3.36440066,8.18300654 L2.50076429,8.18300654 L2.50076429,6.50980392 L5.09167338,6.50980392 L5.09167338,4.83660131 C5.09167338,4.37456314 5.47834066,4 5.95530975,4 L18.0462188,4 C18.5232052,4 18.9098552,4.37456314 18.9098552,4.83660131 L18.9098552,6.50980392 L21.5007643,6.50980392 L21.5007643,8.18300654 L20.6371279,8.18300654 L20.6371279,18.3267974 L21.5007643,18.3267974 L21.5007643,20 L2.50076429,20 L2.50076429,18.3267974 L3.36440066,18.3267974 Z M12.8644007,18.3267974 L12.8644007,11.5294118 L11.1371279,11.5294118 L11.1371279,18.3267974 L12.8644007,18.3267974 Z M8.54621884,18.3267974 L8.54621884,11.5294118 L6.81894611,11.5294118 L6.81894611,18.3267974 L8.54621884,18.3267974 Z M17.1825825,18.3267974 L17.1825825,11.5294118 L15.4553097,11.5294118 L15.4553097,18.3267974 L17.1825825,18.3267974 Z M6.81894611,5.67320261 L6.81894611,6.50980392 L17.1825825,6.50980392 L17.1825825,5.67320261 L6.81894611,5.67320261 Z"
                                    id="形状"
                                   fill="currentColor"
                                    fill-rule="nonzero"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const successCases2Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab4_icon_jiaoyu02</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="切图" transform="translate(-684, -6136)">
                <g id="编组" transform="translate(0, 6049)">
                    <g transform="translate(83, -30)" id="编组-26">
                        <g transform="translate(418, 102)">
                            <g id="编组-25备份-15" transform="translate(159, 0)">
                                <g id="tab4_icon_jiaoyu02" transform="translate(24, 15)">
                                    <rect id="矩形" x="0" y="0" width="24" height="23.9999924"></rect>
                                    <path
                                        d="M11.4835949,3.07918168 L2.24584713,8.7920125 C1.99839899,8.94503999 1.92185593,9.26968963 2.07488342,9.51713777 C2.11784624,9.58660939 2.17637551,9.64513867 2.24584713,9.68810148 L11.4835957,15.4009328 C11.6533927,15.5059391 11.8679588,15.5059394 12.0377561,15.4009335 L19.4895669,10.7925926 C19.7370154,10.6395657 20.0616649,10.7161096 20.2146917,10.9635581 C20.2661749,11.0468079 20.2934459,11.142755 20.2934459,11.2406378 L20.2934459,16.4023919 C20.2934459,16.6933352 20.5293021,16.9291913 20.8202454,16.9291913 L21.4732006,16.9291913 C21.7641439,16.9291913 22,16.6933352 22,16.4023919 L22,9.53366986 C22,9.35114567 21.9055187,9.18162766 21.7502814,9.08562537 L12.0377564,3.07918168 C11.867959,2.97417511 11.6533923,2.97417511 11.4835949,3.07918168 Z M4.93362323,14.2473621 L4.93362323,17.3815838 L4.93362323,17.3815838 C6.4903589,19.5787766 8.96885562,21 11.760505,21 C14.5520861,21 17.0305999,19.5787766 18.5873185,17.3815838 L18.5870563,14.2479995 C18.587032,13.9570562 18.3511561,13.7212199 18.0602128,13.7212442 C17.9623437,13.7212524 17.8664117,13.7485238 17.783174,13.8000005 L12.0238329,17.3617445 C11.8627249,17.4613784 11.659138,17.4613791 11.4980294,17.3617461 L5.73750285,13.7993172 C5.49005452,13.6462901 5.16540497,13.7228335 5.0123778,13.9702819 C4.96089435,14.0535318 4.93362323,14.1494791 4.93362323,14.2473621 Z"
                                        id="形状结合"
                                       fill="currentColor"
                                        fill-rule="nonzero"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const successCases3Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab4_icon_zhaopin03</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="切图" transform="translate(-807, -6136)">
                <g id="编组" transform="translate(0, 6049)">
                    <g transform="translate(83, -30)" id="编组-26">
                        <g transform="translate(418, 102)">
                            <g id="编组-25备份-16" transform="translate(282, 0)">
                                <g id="tab4_icon_zhaopin03" transform="translate(24, 15)">
                                    <rect id="矩形" x="0" y="0" width="24" height="23.9999924"></rect>
                                    <path
                                        d="M11.0625,14.4399048 L11.0625,20.0952381 L12.9375,20.0952381 L12.9375,14.4399048 C16.6371563,14.9085714 19.5,18.1146667 19.5,22 L4.5,22 C4.5,18.1146667 7.36283438,14.9085714 11.0625,14.4399048 Z M12,13.4285714 C8.8921875,13.4285714 6.375,10.8714286 6.375,7.71428571 C6.375,4.55714286 8.8921875,2 12,2 C15.1078125,2 17.625,4.55714286 17.625,7.71428571 C17.625,10.8714286 15.1078125,13.4285714 12,13.4285714 Z"
                                        id="形状"
                                       fill="currentColor"
                                        fill-rule="nonzero"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const successCases4Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab4_icon_jinrong04</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="切图" transform="translate(-930, -6136)">
                <g id="编组" transform="translate(0, 6049)">
                    <g transform="translate(83, -30)" id="编组-26">
                        <g transform="translate(418, 102)">
                            <g id="编组-25备份-17" transform="translate(405, 0)">
                                <g id="tab4_icon_jinrong04" transform="translate(23.9982, 15)">
                                    <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                                    <path
                                        d="M3.5,3.5 L20.5,3.5 C21.0522847,3.5 21.5,3.94771525 21.5,4.5 L21.5,19.5 C21.5,20.0522847 21.0522847,20.5 20.5,20.5 L3.5,20.5 C2.94771525,20.5 2.5,20.0522847 2.5,19.5 L2.5,4.5 C2.5,3.94771525 2.94771525,3.5 3.5,3.5 Z M16.655,12.9444444 L11.05,12.9444444 L11.05,7.37224111 C8.881872,7.80977389 7.25,9.71542667 7.25,12 C7.25,14.6079889 9.376651,16.7222222 12,16.7222222 C14.29805,16.7222222 16.214865,15.0998556 16.655,12.9444444 Z M16.655,11.0555556 C16.277185,9.20526611 14.811145,7.74782778 12.95,7.37224111 L12.95,11.0555556 L16.655,11.0555556 Z"
                                        id="形状"
                                       fill="currentColor"
                                        fill-rule="nonzero"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const successCases5Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab4_icon_nengyuan05</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="切图" transform="translate(-1053, -6136)">
                <g id="编组" transform="translate(0, 6049)">
                    <g transform="translate(83, -30)" id="编组-26">
                        <g transform="translate(418, 102)">
                            <g id="编组-25备份-19" transform="translate(528, 0)">
                                <g id="tab4_icon_nengyuan05" transform="translate(24, 15)">
                                    <rect id="矩形" x="0" y="0" width="24" height="23.9999924"></rect>
                                    <path
                                        d="M16.8889,7 L7.11111,7 L7.82598,3.78307 C7.92766,3.32553 8.33347,3 8.80217,3 L15.1978,3 C15.6665,3 16.0723,3.32553 16.174,3.78307 L16.8889,7 Z"
                                        id="路径"
                                       fill="currentColor"
                                    ></path>
                                    <path
                                        d="M7.69544,8.96113439 L6.69650827,10.0528656 L10.84644,13.8561344 L4.74822944,19.4471344 L5.21944,19.9611344 L4.44444,19.961893 L6.70876414,8.96189305 L7.69544,8.96113439 Z M11.95644,14.8731344 L17.50644,19.9611344 L6.40644,19.9611344 L11.95644,14.8731344 Z M17.40244,9.88113439 L19.60144,19.8471344 L13.06544,13.8561344 L17.40244,9.88113439 Z M16.18644,8.96113439 L11.95544,12.8391344 L7.72544,8.96113439 L16.18644,8.96113439 Z"
                                        id="形状结合"
                                       fill="currentColor"
                                    ></path>
                                    <rect id="矩形-25"fill="currentColor" x="4" y="8" width="16" height="2"></rect>
                                    <rect id="矩形-26"fill="currentColor" x="3" y="19" width="18" height="2"></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const successCases6Svg = (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>tab4_icon_shouji06</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="切图" transform="translate(-1176, -6136)">
                <g id="编组" transform="translate(0, 6049)">
                    <g transform="translate(83, -30)" id="编组-26">
                        <g transform="translate(418, 102)">
                            <g id="编组-25备份-20" transform="translate(651, 0)">
                                <g id="tab4_icon_shouji06" transform="translate(24, 15)">
                                    <rect id="矩形" x="0" y="0" width="24" height="23.9999924"></rect>
                                    <path
                                        d="M14,5 C14,7.76142375 16.2385763,10 19,10 C19.1689898,10 19.3360215,9.99161647 19.500702,9.97524263 L19.5,21 C19.5,21.5523 19.0523,22 18.5,22 L5.5,22 C4.94772,22 4.5,21.5523 4.5,21 L4.5,3 C4.5,2.44772 4.94772,2 5.5,2 L15.0005351,1.99880052 C14.3723009,2.83466646 14,3.87385547 14,5 Z M12,17 C11.4477,17 11,17.4477 11,18 C11,18.5523 11.4477,19 12,19 C12.5523,19 13,18.5523 13,18 C13,17.4477 12.5523,17 12,17 Z"
                                        id="形状结合"
                                       fill="currentColor"
                                        fill-rule="nonzero"
                                    ></path>
                                    <g id="编组" transform="translate(15, 1)"fill="currentColor" fill-rule="nonzero">
                                        <path
                                            d="M4.46684671,7.6895503 L4.71342584,7.12413974 C5.15289492,6.11608486 5.9445437,5.31346662 6.93228245,4.87438498 L7.69193106,4.53671121 C8.10268887,4.35412553 8.10268887,3.75673071 7.69193106,3.57414504 L6.97486047,3.25534197 C5.96161047,2.80495923 5.15573938,1.97264006 4.7238259,0.930317598 L4.47066896,0.319356127 C4.29413466,-0.106452042 3.70577587,-0.106452042 3.52933046,0.319356127 L3.27608463,0.930317598 C2.84417115,1.97264006 2.03838895,2.80495923 1.02522784,3.25534197 L0.308068356,3.57414504 C-0.102689452,3.75673071 -0.102689452,4.35412553 0.308068356,4.53671121 L1.06762808,4.87438498 C2.05545571,5.31346662 2.84701561,6.11608486 3.28657358,7.12413974 L3.53315271,7.6895503 C3.71359814,8.10347988 4.28640128,8.10347988 4.46684671,7.6895503 Z"
                                            id="路径"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
